import React from "react";
import { Outlet } from "react-router-dom";

function AlterationForm() {
  return <Outlet />;
}

export default AlterationForm;
